import axios from "axios";
import routes from "./routes";
import { getStateValue } from "../root/localStorage";
import { put } from "redux-saga/effects";
// import { logout } from '../shells/TopBar/actions';

export default function* api(action) {
  // const x = getStateValue("user") || null;
  // const token = "0123ce12-4fe7-47e6-b462-e85bf772c1ae"; //(x && x.jwt_token) || localStorage.user_token || null;
  // const token = "9026c93c-08da-4690-bacc-bcd0bf3773e9"; //(x && x.jwt_token) || localStorage.user_token || null;
  const token =
    (window.WebEmbedInterface && window.WebEmbedInterface.provideAuth()) || "";
  const baseUrl =
    process.env.REACT_APP_SC_ENV === "production"
      ? "https://nostrapi.nostragamus.in"
      : //: "http://nostrapi.inkind-prize.kstage.sportscafe.in";
        "https://secure-stage02.nostragamus.in";
  // "http://nostrapi.inkind-prize.kstage.sportscafe.in";
  // "https://api-stage02.sportscafe.in";

  const form = action.containsFormData
    ? { "Content-Type": "multipart/form-data" }
    : {};
  const headers = Object.assign({}, { Authorization: token }, form, {
    "nostra-web": true,
  });
  yield put({ type: "LOADING_START", incomingApi: action.handler });

  try {
    const response = yield axios({
      method: routes[action.handler].method,
      url: baseUrl + routes[action.handler].path,
      data: action.payload || null,
      params: action.query || null,
      // withCredentials: true
      // credentials: 'same-origin',
      headers,
    });

    yield put({ type: "LOADING_STOP", incomingApi: action.handler });
    console.log(response);
    return response;
  } catch (error) {
    if (error && error.response) {
      if (error.response.status === 401) {
        yield put({ type: "USER_LOGOUT" });
        yield put({ type: "NAVIGATE", path: "/logout" });
        console.log(error);
      } else {
        console.log(error);

        return error.response;
      }
    } else {
      // Catching Unauthorized errors
      console.log(error);
      yield put({ type: "USER_LOGOUT" });
    }
    // returning dummy data to ensure the calling saga doesnt get stuck
    console.log(error);
    return { data: { data: null }, error };
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js